module.exports = __webpack_public_path__ + "img/icon-uncollect.d8a463dd.svg";